import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountManagementComponent } from './account-management.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { MatSortModule } from '@angular/material/sort';
import { SearchBoxModule } from '../shared/search-box/search-box.module';


@NgModule({
  declarations: [
    AccountManagementComponent
  ],
  imports: [
    CommonModule,
    MatTableModule,
    NgbModule,
    InfiniteScrollModule,
    MatCheckboxModule,
    FormsModule,
    MatSortModule,
    SearchBoxModule
  ]
})
export class AccountManagementModule { }
